module.exports = __webpack_public_path__ + "img/ring_y_c_0_1@3x.a14f877e.png";